import React, {useState, useEffect, useCallback, useRef} from 'react';
import {useContextSelector, useContext} from 'use-context-selector';
import {useHistory} from 'react-router-dom';
import {Modal, Button, Row, Col, Card, ListGroup} from 'react-bootstrap';
import {faEnvelope} from '@fortawesome/free-solid-svg-icons/faEnvelope';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import {faBuilding} from '@fortawesome/free-solid-svg-icons/faBuilding';
import {faSyncAlt} from '@fortawesome/free-solid-svg-icons/faSyncAlt';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useTranslation} from 'react-i18next';

import ModalRef from '../util/ModalRef';
import {useBreakpoint} from '../util/handleBreakpoints';
import {SessionContext} from '../context/SessionContext';
import {LocalContext} from '../context/LocalContext';
import ProvidersCheckoutContact from './ProvidersCheckoutContact';
import useCreateClientStatusMessage from '../util/useCreateClientStatusMessage';

import useGetProvidersSummaryPDFURL from './useGetProvidersSummaryPDFURL';
import useGetProvidersSummaryPDFFile from './useGetProvidersSummaryPDFFile';

const ProvidersCheckout = (props) => {
    const isMounted = useRef(null);
    const [sessionData, setSessionData] = useContext(SessionContext);
    const breakpoints = useBreakpoint();
    const {t} = useTranslation();
    const createClientStatusMessage = useCreateClientStatusMessage();
    const getProvidersSummaryPDFURL = useGetProvidersSummaryPDFURL();
    const getProvidersSummaryPDFFile = useGetProvidersSummaryPDFFile();
    const history = useHistory();

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        }
    }, []);

    const clientOnline = useContextSelector(LocalContext, v => v[0].clientOnline);

    const [modeContactProviders, setModeContactProviders] = useState(false);
    const [providersContacted, setProvidersContacted] = useState(false);
    const [providersContactedMessage, setProvidersContactedMessage] = useState(null);
    const [providersContactedMessageSeen, setProvidersContactedMessageSeen] = useState(false);

    const [providersContactedError, setProvidersContactedError] = useState(false);

    const [isLoadingGetProvidersSummaryPDF, setIsLoadingGetProvidersSummaryPDF] = useState(false);
    // const [isLoadedGetProvidersSummaryPDF, setIsLoadedGetProvidersSummaryPDF] = useState(false);
    // const [isErrorGetProvidersSummaryPDF, setIsErrorGetProvidersSummaryPDF] = useState(false);
    const setIsLoadedGetProvidersSummaryPDF = useState(false)[1];
    const setIsErrorGetProvidersSummaryPDF = useState(false)[1];

    const handleGetProvidersSummaryPDF = useCallback(
        async () => {
            setIsLoadingGetProvidersSummaryPDF(true);

            let response;
            try {
                response = await getProvidersSummaryPDFURL(props.providersSelected);
            } catch (error) {
                if (isMounted.current) {
                    setIsErrorGetProvidersSummaryPDF(true);
                    createClientStatusMessage(error.clientStatusMessage);
                    setIsLoadingGetProvidersSummaryPDF(false);
                    return
                }
            }

            let fileBlob;
            try {
                fileBlob = await getProvidersSummaryPDFFile(response.pdf);
            } catch (error) {
                setIsErrorGetProvidersSummaryPDF(true);
                createClientStatusMessage(error.clientStatusMessage);
                setIsLoadingGetProvidersSummaryPDF(false);
                return
            }


            if (isMounted.current) {
                const fileURLObj = window.URL.createObjectURL(fileBlob);
                const fileAnchorElem = document.createElement('a');
                fileAnchorElem.href = fileURLObj;
                fileAnchorElem.download = `providers-summary-${Math.round(+new Date() / 1000)}-innocape.pdf`;
                fileAnchorElem.click();
                setIsLoadingGetProvidersSummaryPDF(false);
                setIsLoadedGetProvidersSummaryPDF(true);
            }
        },
        [
            setIsLoadedGetProvidersSummaryPDF,
            setIsLoadingGetProvidersSummaryPDF,
            setIsErrorGetProvidersSummaryPDF,
            createClientStatusMessage,
            getProvidersSummaryPDFFile,
            isMounted,
            getProvidersSummaryPDFURL,
            props.providersSelected
        ]
    )


    const onHide = () => {
        props.setModeProvidersCheckout(false);
    }

    const onShow = () => {
    }

    return (
        modeContactProviders ?
            <ProvidersCheckoutContact
                providersSelected={props.providersSelected}
                setModeContactProviders={setModeContactProviders}
                setModeProvidersCheckout={props.setModeProvidersCheckout}
                setProvidersContacted={setProvidersContacted}
                setProvidersContactedMessage={setProvidersContactedMessage}
                setProvidersContactedMessageSeen={setProvidersContactedMessageSeen}
                setProvidersContactedError={setProvidersContactedError}
                filters={props.filters}
                spawnedFrom="search"
            /> : <Modal
                container={ModalRef}
                show={true}
                size="lg"
                backdrop="static"
                animation={false}
                onHide={onHide}
                onShow={onShow}
                keyboard={false}
                key="modalProvidersCheckout"
            >
                <style>
                    {
                        (breakpoints.md || breakpoints.sm) && !breakpoints.xs ?
                            `
                            .modal-dialog {
                                max-width: calc(100% - 4rem);
                            }
                        ` : `
                            .modal-dialog {
                                max-width: 60rem;
                                    
                            }
                        `
                    }
                </style>
                <Modal.Header
                    style={
                        {
                            backgroundColor: 'var(--light)',
                        }

                    }
                    closeButton={!providersContacted && !isLoadingGetProvidersSummaryPDF}
                >
                    <div>
                        <strong>{t('Providers.ProvidersCheckout.x-selected-providers.p1')}{props.providersSelected.length}{t('Providers.ProvidersCheckout.x-selected-providers.p2')}</strong>
                    </div>
                    {/* {t('Providers.ProvidersCheckout.selected-providers')} */}
                </ Modal.Header>
                <Modal.Body
                    className="p-0 bg-light"


                >
                    {
                        (providersContacted || providersContactedError) && !providersContactedMessageSeen ?
                            (<Row>
                                <Col>
                                    {providersContactedMessage}
                                </Col>
                            </Row>)
                            : null
                    }
                    <Row>
                        <Col>
                            <div
                                style={
                                    {
                                        display: 'flex',
                                        flexDirection: `column`,
                                        overflow: `auto`,
                                        padding: '1rem',
                                        paddingTop: '0.5rem',
                                        paddingBottom: 0,
                                    }
                                }

                            >
                                <Card
                                    style={
                                        {
                                            flexShrink: 0,
                                            flexGrow: 1,
                                            overflow: 'hidden',
                                            margin: '1rem',
                                            marginBottom: 0
                                        }
                                    }
                                >
                                    <ListGroup
                                        variant="flush"
                                        style={
                                            {
                                                maxHeight: '500px',
                                                overflow: 'auto',
                                            }
                                        }
                                    >
                                        <div>
                                            {props.providersSelected.map((provider, index) => {
                                                return <ListGroup.Item
                                                    key={provider.id}
                                                    style={
                                                        {
                                                            padding: '1.25rem 1.75rem',
                                                        }
                                                    }
                                                >
                                                    <div
                                                        className="d-flex align-items-center"

                                                        style={
                                                            {
                                                                maxWidth: `100%`,
                                                                width: `100%`,
                                                                flexGrow: 0
                                                            }
                                                        }
                                                    >
                                                        <span
                                                            style={
                                                                {
                                                                    display: 'flex',
                                                                    flexGrow: 0,
                                                                    flexShrink: 1,
                                                                    overflow: 'hidden',
                                                                }
                                                            }
                                                        >
                                                            <a
                                                                href={`/provider/${provider.id}`}
                                                                className="text-decoration-none text-dark"
                                                                rel="noopener noreferrer"
                                                                target="_blank"
                                                                title={`${t('Providers.ProvidersCheckout.view-in-new-tab.p1')}“${provider.title}”${t('Providers.ProvidersCheckout.view-in-new-tab.p2')}`}
                                                                style={
                                                                    {
                                                                        whiteSpace: `nowrap`,
                                                                        overflow: `hidden`,
                                                                        textOverflow: `ellipsis`
                                                                    }
                                                                }
                                                            >
                                                                <span className="mr-3"><FontAwesomeIcon size="sm" icon={faBuilding} /></span>
                                                                <span><strong>{provider.title}</strong></span>
                                                            </a>
                                                        </span>
                                                        {/* <span className="ml-2 mr-4 text-primary"> */}
                                                        {/*     <FontAwesomeIcon size="xs" icon={faCheck} /> */}
                                                        {/* </span> */}
                                                        <div
                                                            style={
                                                                {
                                                                    flexGrow: 0,
                                                                    marginLeft: `auto`
                                                                }

                                                            }
                                                        >
                                                            {!providersContacted ?
                                                                <Button
                                                                    onClick={() => {
                                                                        const newArray = [...props.providersSelected];
                                                                        newArray.splice(index, 1);
                                                                        props.setProvidersSelected(newArray);
                                                                        if (newArray.length === 0) {
                                                                            setSessionData(
                                                                                {
                                                                                    ...sessionData,
                                                                                    modalVisible: false
                                                                                }
                                                                            )
                                                                            props.setModeProvidersCheckout(false);
                                                                        }
                                                                    }}
                                                                    size="sm"
                                                                    className="ml-auto"
                                                                    disabled={isLoadingGetProvidersSummaryPDF}
                                                                    variant="primary"
                                                                >{t('Providers.ProvidersCheckout.remove')}</Button> :
                                                                null
                                                            }
                                                        </div>
                                                    </div>
                                                </ListGroup.Item>
                                            })}
                                        </div>

                                    </ListGroup>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer
                    style={
                        {
                            justifyContent: 'flex-start',
                            padding: '1rem',
                            backgroundColor: 'var(--light)',
                            borderTop: 'none'
                        }
                    }
                >
                    <div
                        style={
                            {
                                margin: 0,
                                padding: '1rem 1rem',
                            }
                        }
                    >
                        <h2 className="mb-0">{t('Providers.ProvidersCheckout.next-action-header')}</h2>
                    </div>
                    <div
                        style={
                            {
                                position: 'relative',
                                width: '100%'
                            }
                        }
                    >
                        <div
                            style={
                                {
                                    display: 'grid',
                                    width: '100%',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(18rem, 1fr) )',
                                    gridGap: '1rem',
                                    padding: '1rem',
                                    paddingTop: 0,
                                    margin: 0,
                                }
                            }
                        >
                            <Card>
                                <Card.Body
                                    style={
                                        {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '1.5rem'
                                        }
                                    }
                                >
                                    <div
                                        style={
                                            {
                                                textAlign: 'center'
                                            }
                                        }
                                    >
                                        <div
                                            style={
                                                {
                                                    paddingBottom: '1rem',
                                                    paddingTop: '1rem'
                                                }
                                            }
                                        >
                                            <p>{t('Providers.ProvidersCheckout.explanation-get-summary')}</p>
                                        </div>
                                    </div>
                                    <div
                                        style={
                                            {
                                                marginTop: 'auto',
                                                paddingTop: '1rem',
                                            }
                                        }
                                    >
                                        <Button
                                            size={breakpoints.xs ? "md" : "lg"}
                                            className="btn-block"
                                            variant="primary"
                                            disabled={!clientOnline || props.providersSelected.length === 0 || props.providersSelected.length > process.env.REACT_APP_PROVIDERS_SELECT_PDF_SUMMARY_MAX_COUNT || isLoadingGetProvidersSummaryPDF}
                                            style={
                                                {
                                                    borderRadius: '5rem',
                                                }
                                            }
                                            onClick={
                                                async (event) => {
                                                    event.preventDefault();
                                                    await handleGetProvidersSummaryPDF();
                                                }
                                            }
                                        >
                                            <span>
                                                {isLoadingGetProvidersSummaryPDF ? <span className="mr-2">
                                                    <FontAwesomeIcon
                                                        spin={isLoadingGetProvidersSummaryPDF}
                                                        size="sm"
                                                        icon={faSyncAlt}
                                                    />
                                                </span> : null}
                                                <span>{t('Providers.ProvidersCheckout.get-summary-file')}</span>
                                            </span>

                                        </Button>
                                    </div>
                                    <div
                                        style={
                                            {
                                                textAlign: 'center',
                                                marginTop: '1rem'
                                            }
                                        }
                                    >
                                        <span
                                            className="text-muted"
                                            style={
                                                {
                                                    fontSize: '0.85rem',
                                                    padding: '0.5rem 0',
                                                    borderRadius: '10rem'
                                                }
                                            }
                                        ><span className="mr-2"><FontAwesomeIcon size='sm' icon={faInfoCircle} /></span><span>{t('Providers.ProvidersCheckout.message-max-selected-pdf-summary.p1')}<strong>{process.env.REACT_APP_PROVIDERS_SELECT_PDF_SUMMARY_MAX_COUNT}</strong>{t('Providers.ProvidersCheckout.message-max-selected-pdf-summary.p2')}</span></span>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Body
                                    style={
                                        {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '1.5rem'
                                        }
                                    }
                                >
                                    <div
                                        style={
                                            {
                                                textAlign: 'center'
                                            }
                                        }
                                    >
                                        <div
                                            style={
                                                {
                                                    paddingBottom: '1rem',
                                                    paddingTop: '1rem'
                                                }
                                            }
                                        >
                                            <p>{t('Providers.ProvidersCheckout.explanation-contact-selected-providers')}</p>
                                        </div>
                                    </div>
                                    <div
                                        style={
                                            {
                                                marginTop: 'auto',
                                                paddingTop: '1rem',
                                            }
                                        }
                                    >
                                        <Button
                                            disabled={providersContacted || props.providersSelected.length === 0 || props.providersSelected.length > process.env.REACT_APP_PROVIDERS_SELECT_CONTACT_MAX_COUNT || isLoadingGetProvidersSummaryPDF}
                                            variant="primary"
                                            className="btn-block"
                                            size={breakpoints.xs ? "md" : "lg"}
                                            style={
                                                {
                                                    borderRadius: '5rem'
                                                }
                                            }
                                            onClick={
                                                () => {
                                                    setModeContactProviders(true);
                                                }
                                            }
                                        ><span className="mx-2"><FontAwesomeIcon icon={faEnvelope} /></span>{t('Providers.ProvidersCheckout.contact-selected-providers')}</Button>
                                    </div>
                                    <div
                                        style={
                                            {
                                                textAlign: 'center',
                                                marginTop: '1rem'
                                            }
                                        }
                                    >
                                        <span
                                            className="text-muted"
                                            style={
                                                {
                                                    fontSize: '0.85rem',
                                                    padding: '0.5rem 0',
                                                    borderRadius: '10rem'
                                                }
                                            }
                                        ><span className="mr-2"><FontAwesomeIcon size='sm' icon={faInfoCircle} /></span><span>{t('Providers.ProvidersCheckout.message-max-selected-contact-message.p1')}<strong>{process.env.REACT_APP_PROVIDERS_SELECT_CONTACT_MAX_COUNT}</strong>{t('Providers.ProvidersCheckout.message-max-selected-contact-message.p2')}</span></span>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                </Modal.Footer>
                {providersContacted ?
                    <Modal.Footer>
                        <Button
                            onClick={
                                () => {
                                    // props.handleResetProvidersState();
                                    history.push('/')
                                    // onHide();
                                }
                            }
                            className={breakpoints.xs ? "btn-block" : "ml-auto"}
                            variant="primary"
                        >
                            {t('Providers.ProvidersCheckout.finish-this-search')}
                        </Button>
                    </Modal.Footer> : null}
            </Modal>
    )
}

export default ProvidersCheckout;
